var _line, _line2, _path, _line3, _line4, _line5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPipeMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 3776,
    viewBox: "0 0 45 3776",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: -9.83506e-7,
    x2: 22.5,
    y2: 254,
    stroke: "url(#paint0_linear_1_521)",
    strokeWidth: 45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 1699,
    x2: 22.5001,
    y2: 3776,
    stroke: "#BED4ED",
    strokeWidth: 45
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 1144L22.5 1699",
    stroke: "#BED4ED",
    strokeWidth: 45
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 811,
    x2: 22.5,
    y2: 1144,
    stroke: "#BED4ED",
    strokeWidth: 45
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 326,
    x2: 22.5,
    y2: 785,
    stroke: "#BED4ED",
    strokeWidth: 45
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 22.5,
    y1: 1699,
    x2: 22.5,
    y2: 1999,
    stroke: "#BED4ED",
    strokeWidth: 45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 686L3.01195 669.203L41.9511 669.203L22.4815 686Z",
    fill: "url(#paint1_linear_1_521)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 672.198L3.03052 655.4L41.9696 655.4L22.5001 672.198Z",
    fill: "url(#paint2_linear_1_521)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 658.396L3.04909 641.599L41.9882 641.599L22.5187 658.396Z",
    fill: "url(#paint3_linear_1_521)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 1144L3.01195 1127.2L41.9511 1127.2L22.4815 1144Z",
    fill: "url(#paint4_linear_1_521)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 1130.2L3.03052 1113.4L41.9696 1113.4L22.5001 1130.2Z",
    fill: "url(#paint5_linear_1_521)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 1116.4L3.04909 1099.6L41.9882 1099.6L22.5187 1116.4Z",
    fill: "url(#paint6_linear_1_521)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 1688L3.01195 1671.2L41.9511 1671.2L22.4815 1688Z",
    fill: "url(#paint7_linear_1_521)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 1674.2L3.03052 1657.4L41.9696 1657.4L22.5001 1674.2Z",
    fill: "url(#paint8_linear_1_521)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 1660.4L3.04909 1643.6L41.9882 1643.6L22.5187 1660.4Z",
    fill: "url(#paint9_linear_1_521)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 1928L3.01195 1911.2L41.9511 1911.2L22.4815 1928Z",
    fill: "url(#paint10_linear_1_521)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 1914.2L3.03052 1897.4L41.9696 1897.4L22.5001 1914.2Z",
    fill: "url(#paint11_linear_1_521)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 1900.4L3.04909 1883.6L41.9882 1883.6L22.5187 1900.4Z",
    fill: "url(#paint12_linear_1_521)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 2973L3.01195 2956.2L41.9511 2956.2L22.4815 2973Z",
    fill: "url(#paint13_linear_1_521)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 2959.2L3.03052 2942.4L41.9696 2942.4L22.5001 2959.2Z",
    fill: "url(#paint14_linear_1_521)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 2945.4L3.04909 2928.6L41.9882 2928.6L22.5187 2945.4Z",
    fill: "url(#paint15_linear_1_521)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 202L3.01195 185.203L41.9511 185.203L22.4815 202Z",
    fill: "url(#paint16_linear_1_521)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 188.198L3.03052 171.4L41.9696 171.4L22.5001 188.198Z",
    fill: "url(#paint17_linear_1_521)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 174.396L3.04909 157.599L41.9882 157.599L22.5187 174.396Z",
    fill: "url(#paint18_linear_1_521)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 2143L3.01195 2126.2L41.9511 2126.2L22.4815 2143Z",
    fill: "url(#paint19_linear_1_521)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 2129.2L3.03052 2112.4L41.9696 2112.4L22.5001 2129.2Z",
    fill: "url(#paint20_linear_1_521)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 2115.4L3.04909 2098.6L41.9882 2098.6L22.5187 2115.4Z",
    fill: "url(#paint21_linear_1_521)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4815 3218L3.01195 3201.2L41.9511 3201.2L22.4815 3218Z",
    fill: "url(#paint22_linear_1_521)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5001 3204.2L3.03052 3187.4L41.9696 3187.4L22.5001 3204.2Z",
    fill: "url(#paint23_linear_1_521)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5187 3190.4L3.04909 3173.6L41.9882 3173.6L22.5187 3190.4Z",
    fill: "url(#paint24_linear_1_521)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_521",
    x1: -8.49999,
    y1: 413.898,
    x2: 11.3745,
    y2: 0.546903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A0D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70A0D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_521",
    x1: 22.4815,
    y1: 686,
    x2: 22.4815,
    y2: 663.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_521",
    x1: 22.5001,
    y1: 672.198,
    x2: 22.5001,
    y2: 649.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_521",
    x1: 22.5187,
    y1: 658.396,
    x2: 22.5186,
    y2: 636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_521",
    x1: 22.4815,
    y1: 1144,
    x2: 22.4815,
    y2: 1121.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_521",
    x1: 22.5001,
    y1: 1130.2,
    x2: 22.5001,
    y2: 1107.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_521",
    x1: 22.5187,
    y1: 1116.4,
    x2: 22.5186,
    y2: 1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_521",
    x1: 22.4815,
    y1: 1688,
    x2: 22.4815,
    y2: 1665.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_521",
    x1: 22.5001,
    y1: 1674.2,
    x2: 22.5001,
    y2: 1651.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_521",
    x1: 22.5187,
    y1: 1660.4,
    x2: 22.5186,
    y2: 1638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_521",
    x1: 22.4815,
    y1: 1928,
    x2: 22.4815,
    y2: 1905.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_521",
    x1: 22.5001,
    y1: 1914.2,
    x2: 22.5001,
    y2: 1891.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_521",
    x1: 22.5187,
    y1: 1900.4,
    x2: 22.5186,
    y2: 1878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_521",
    x1: 22.4815,
    y1: 2973,
    x2: 22.4815,
    y2: 2950.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_521",
    x1: 22.5001,
    y1: 2959.2,
    x2: 22.5001,
    y2: 2936.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_521",
    x1: 22.5187,
    y1: 2945.4,
    x2: 22.5186,
    y2: 2923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_521",
    x1: 22.4815,
    y1: 202,
    x2: 22.4815,
    y2: 179.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_521",
    x1: 22.5001,
    y1: 188.198,
    x2: 22.5001,
    y2: 165.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_521",
    x1: 22.5187,
    y1: 174.396,
    x2: 22.5186,
    y2: 152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_521",
    x1: 22.4815,
    y1: 2143,
    x2: 22.4815,
    y2: 2120.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_521",
    x1: 22.5001,
    y1: 2129.2,
    x2: 22.5001,
    y2: 2106.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_521",
    x1: 22.5187,
    y1: 2115.4,
    x2: 22.5186,
    y2: 2093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_521",
    x1: 22.4815,
    y1: 3218,
    x2: 22.4815,
    y2: 3195.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_521",
    x1: 22.5001,
    y1: 3204.2,
    x2: 22.5001,
    y2: 3181.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_521",
    x1: 22.5187,
    y1: 3190.4,
    x2: 22.5186,
    y2: 3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeMobile);
export default __webpack_public_path__ + "static/media/pipe-mobile.014df1187975919d95266a423754bebb.svg";
export { ForwardRef as ReactComponent };